import { useState, useEffect } from "react"
import propTypes from "prop-types"
import { Formik } from "formik"
import { Button, Form, Input, Label, Alert, Row, Col } from "reactstrap"

import { Loading, RequiredIcon } from "components"
import ErrorsText from "components/ErrorsText"
import schema from "./schema"

const BrandForm = ({ isCreate, submit, data, toggle, isLoading, isError, error }) => {
  const [showErrorAlert, setShowErrorAlert] = useState(false)
  const [validationErrors, setValidationErrors] = useState([])

  useEffect(() => {
    if (isError && error?.error_type !== "ValidationError") {
      setShowErrorAlert(true)
    } else if (isError && error?.error_type === "ValidationError") {
      setValidationErrors(error.errors)
    } else if (!isError) {
      setValidationErrors([])
      setShowErrorAlert(false)
    }
  }, [isError])

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          name: data?.name ?? "",
        }}
        validationSchema={schema}
        onSubmit={submit}
      >
        {({ values, setFieldValue, handleChange, handleSubmit, handleBlur, touched, errors, setTouched }) => (
          <Form className="form-horizontal" onSubmit={handleSubmit}>
            <Alert color="danger" isOpen={showErrorAlert} toggle={() => setShowErrorAlert(false)}>
              {isError && error?.errors?.map((error) => error?.message)}
            </Alert>

            <Row className="mb-3">
              <Col>
                <Label className="form-label">
                  Nombre <RequiredIcon />
                </Label>
                <Input
                  autoComplete="off"
                  className="form-control"
                  name="name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="name"
                  value={values.name}
                  invalid={
                    !!(touched.name && errors.name) ||
                    (isError && validationErrors.findIndex((e) => e.field === "name") >= 0)
                  }
                />
                <ErrorsText
                  errorsBack={error}
                  errorsForm={errors}
                  formName="name"
                  isErrorBack={isError}
                  touched={touched}
                />
              </Col>
            </Row>

            <hr />

            <Row>
              <Col className="d-flex justify-content-end">
                <Button className="mx-3" color="secondary" onClick={toggle} disabled={isLoading}>
                  <i className="fa fa-times" /> Cerrar
                </Button>
                <Button color="success" type="submit" disabled={isLoading}>
                  <Loading isLoading={isLoading} /> <i className="fa fa-save" /> Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

BrandForm.defaultProps = {
  data: null,
}

BrandForm.propTypes = {
  isCreate: propTypes.bool,
  submit: propTypes.func,
  toggle: propTypes.func,
  data: propTypes.any,
  isLoading: propTypes.bool,
  isError: propTypes.bool,
  error: propTypes.any,
}

export default BrandForm
